
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.13 8.665l-2.4-2.4a.764.764 0 00-.5-.2h-2.4v-3.3a.472.472 0 00-.5-.5H1.23a.472.472 0 00-.5.5v10.6a.472.472 0 00.5.5h1.3a2.763 2.763 0 00-.1 2.2 2.59 2.59 0 001.9 1.6 2.734 2.734 0 003.3-2.6 2.663 2.663 0 00-.3-1.2h5.3a2.763 2.763 0 00-.1 2.2 2.59 2.59 0 001.9 1.6 2.734 2.734 0 003.3-2.6 2.663 2.663 0 00-.3-1.2h1.3a.472.472 0 00.5-.5v-4.2a.44.44 0 00-.1-.5zm-13 6.4a1.155 1.155 0 01-1.2 1.2 1.2 1.2 0 010-2.4 1.155 1.155 0 011.2 1.2zm6.2-2.7H2.23v-8.6h10.2v8.6zm3.9 2.7a1.2 1.2 0 11-1.2-1.2 1.155 1.155 0 011.2 1.2zm1.6-2.7h-3.9v-4.8h2c.1 0 .1 0 .1.1l1.8 1.8.1.1v2.8z"}})])
          )
        }
      }
    